var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('b-overlay',{attrs:{"show":_vm.loading,"variant":"light","opacity":"0.5","rounded":"false"}},[_c('ValidationObserver',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('JurisdictionLayout',{attrs:{"route-from":_vm.routeFrom},on:{"loading":function ($event) { return _vm.loading = $event; },"cancel":function($event){_vm.currentOrganisation && _vm.currentOrganisation.id ?
            _vm.$router.push({
              name: 'OrganisationDetail',
              params: {
                id: _vm.currentOrganisation.id
              }
            }) :
            { name: 'Organisations'}},"save-continue":function($event){handleSubmit(function () { return _vm.createJurisdiction(true); })},"save":function($event){return handleSubmit(_vm.createJurisdiction)}}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }